import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
  background-color: var(--p-section-bg);
  container-type: inline-size;
}

:host([dark]) {
  --p-section-bg: var(--p-bg-dark);
}

.video-hero {
  position: relative;
  width: min(var(--p-outer-wrap-width), 100%);
  margin-inline: auto;
  aspect-ratio: 16/9;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

}

.container {
  width: min(var(--p-container-width), 100% - 2 * var(--p-gap));
  margin-inline: auto;
  padding-bottom: var(--p-gap);
}

@container (max-width: 768px) {
  .video-hero {
    aspect-ratio: unset;
  }
  .container {
    width: 100%;
  }

}

/**
--------------------------------------------------
* Featured poster
--------------------------------------------------
*/
.featured-poster {
  background-color: var(--p-bg-dark);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  bottom: var(--p-gap);
  z-index: 0;
}

.featured-poster figure {
  height: 100%;
}

.featured-poster img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.featured-poster::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 35%;
  background: linear-gradient(0deg, rgb(var(--p-video-hero-overlay-rgb)) 0%, transparent 100%);
  z-index: 1;
}

.featured-poster::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgb(var(--p-video-hero-overlay-rgb)) 0%, rgb(var(--p-video-hero-overlay-rgb), .7) 35%, transparent 50%, transparent 100%);
  z-index: 1;
}

.hide-text .featured-poster::after {
  display: none;
}

@container (max-width: 768px) {
  .featured-poster {
    position: relative;
  }

   .featured-poster::after {
    display: none;
  }
}

/**
--------------------------------------------------
* Featured content
--------------------------------------------------
*/
.featured-content {
  position: relative;
  z-index: 2;
  max-width: 600px;
  padding: 10vh 0 var(--p-gap);
}

.featured-content h1, .featured-content h2 {
  font-family: var(--p-h1-font);
  font-size: var(--p-h1-font-size);
  font-weight: var(--p-h1-font-weight);
  font-style: var(--p-h1-font-style);
  line-height: var(--p-h1-line-height);
  text-transform: var(--p-h1-transform);
  letter-spacing: var(--p-h1-letter-spacing);
  margin: 0 0 var(--p-h1-margin-bottom);
  color: var(--p-heading-color);
}

.featured-content p {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: var(--p-text-color);
}

@media (max-width: 768px) {
  .featured-content {
    padding: var(--p-gap);
  }
}

/**
--------------------------------------------------
* Bottom grid
--------------------------------------------------
*/
.grid {
  position: relative;
  z-index: 1;
  display: grid;
  gap: var(--p-gap);
  grid-template-columns: repeat(3, 1fr);
}

/* .grid-items-1 {
  grid-template-columns: 2;
} */

/* .grid-items-2 {
  grid-template-columns: repeat(2, 1fr);
}

.grid-items-3 {
  grid-template-columns: repeat(3, 1fr);
} */

/* .grid-items-1 slot[name="card"]::slotted(*) {
  max-width: 50%;
} */


@container (max-width: 768px) {
  .grid {
    padding: var(--p-gap);
    overflow-x: auto;
    display: flex;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch; /* Needed to work on iOS Safari */
  }

  slot[name="card"]::slotted(*) {
    scroll-snap-align: center;
    min-width: 80vw;
    max-width: unset;
  }
}


/**
--------------------------------------------------
* Preview
--------------------------------------------------
*/
.preview .featured-poster{
 background-color: #555;
}

`;
